import * as Sentry from "@sentry/react";
import type { StudyGroupViewRestorationTelemetryEvent } from "@/features/study-group-view-state/telemetry";

export const CEF_SHARP_OBJECT_NOT_FOUND_RE =
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:[^,]+, ParamCount:\d+$/;

export const captureStudyGroupViewRestorationTelemetry = (
  event: StudyGroupViewRestorationTelemetryEvent,
): void => {
  if (typeof window === "undefined" || !Sentry.isInitialized()) return;

  const name = `study_group_view_restoration.${event.metric}`;
  const attributes = {
    ...(event.scopeType ? { scope_type: event.scopeType } : {}),
    ...(event.failure ? { failure: event.failure } : {}),
  };
  if (event.durationMs !== undefined) {
    Sentry.metrics.distribution(name, event.durationMs, {
      unit: "millisecond",
      attributes,
    });
    return;
  }
  if (event.count !== undefined) {
    Sentry.metrics.count(name, event.count, { attributes });
  }
};

export function initSentry(router: unknown) {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    ignoreErrors: [CEF_SHARP_OBJECT_NOT_FOUND_RE],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: import.meta.env.PROD ? 0.01 : 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}
